import React, { useEffect } from 'react';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

const responsiveAd = '7752375161';

const GoogleAd = ({
  adFormat = 'auto'
}: {
  adFormat?: 'auto' | 'horizontal' | 'rectangle' | 'vertical';
}) => {
  useEffect(() => {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);

  return (
    <div className="google-ad">
      <ins className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-0397681406292549"
        data-ad-slot={responsiveAd}
        data-ad-format={adFormat}
        data-full-width-responsive="true"> {/* apparently this should always be true event for vertical ads */}
      </ins>
    </div>
  );
};

export default GoogleAd;